export default class Tab {
    constructor(id, name, path, extension, active) {
        this.saved = true;
        this.active = false;
        this.id = id;
        this.name = name;
        this.path = path;
        this.extension = extension;
        this.active = active;
    }
    getId() {
        return this.id;
    }
    getName() {
        return this.name;
    }
    isActive() {
        return this.active;
    }
    setActive(active) {
        this.active = active;
    }
    isSaved() {
        return this.saved;
    }
    setSaved(saved) {
        this.saved = saved;
    }
    getExtension() {
        return this.extension;
    }
    getPath() {
        return this.path;
    }
}
